<template>
  <v-dialog
    v-model="dialog"
    :transition="transition"
    width="70%"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on">
        Adicionar Indicador
      </v-btn>
    </template>
    <template>
      <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-toolbar class="title" color="primary" tile elevation="0" dark>{{
            titulo
          }}</v-toolbar>

          <v-list>
            <template v-if="impacto">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{
                      impacto.posicaoFormatada
                    }}
                    Impacto</v-list-item-subtitle
                  >
                  <v-list-item-title class="text-wrap">{{
                    impacto.descricao
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
            <template v-if="realizacao">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{
                      realizacao.posicaoFormatada
                    }}
                    Realização</v-list-item-subtitle
                  >
                  <v-list-item-title class="text-wrap">{{
                    realizacao.descricao
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
            <template v-if="produto">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{
                      produto.posicaoFormatada
                    }}
                    Produto</v-list-item-subtitle
                  >
                  <v-list-item-title class="text-wrap">{{
                    produto.descricao
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
            <template v-if="atividade">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{
                      atividade.posicaoFormatada
                    }}
                    Atividade</v-list-item-subtitle
                  >
                  <v-list-item-title class="text-wrap">{{
                    atividade.descricao
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-list>

          <v-card-text>
            <v-row>
              <v-col cols="4" class="mb-n5">
                <v-select
                  class="text-center"
                  :items="[
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                    18, 19, 20,
                  ]"
                  label="Posição"
                  :rules="[(v) => !!v || 'Posição é obrigatória.']"
                  filled
                  v-model="formulario.posicao"
                ></v-select>
              </v-col>
              <v-col cols="8" class="mb-n5">
                <v-autocomplete
                  v-model="formulario.responsavel.id"
                  :items="responsaveis"
                  item-text="usuario.nome"
                  item-value="usuario.id"
                  label="Responsável por Lançamento das Fontes de Verificação"
                  :rules="[(v) => !!v || 'Responsável é obrigatório.']"
                  filled
                  auto-select-first
                ></v-autocomplete>
                <div v-if="responsaveis.length < 1" class="mt-n7 mb-1 error--text text-right">Por favor, cadastre a equipe do projeto.</div>
              </v-col>
              <v-col cols="6" class="mb-n5">
                <v-textarea
                  v-model="formulario.titulo"
                  label="Título"
                  rows="1"
                  :rules="[(v) => !!v || 'Título é obrigatório.']"
                  auto-grow
                  filled
                ></v-textarea>
              </v-col>
              <v-col cols="6" class="mb-n5">
                <v-textarea
                  v-model="formulario.descricao"
                  label="Descrição"
                  rows="1"
                  filled
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="6" class="mb-n5">
                <v-textarea
                  v-model="formulario.descricaoFonteVerificaao"
                  label="Fontes de Verificação"
                  rows="1"
                  filled
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="6" class="mb-n5">
                <v-select
                  v-model="formulariosSelecionados"
                  :items="items"
                  item-text="nome"
                  label="Fontes de Verifição - Formulários"
                  filled
                  multiple
                  return-object
                >
                </v-select>
              </v-col>
              <v-col cols="4" class="mb-n5">
                <v-textarea
                  v-model="formulario.acoes"
                  label="Ações"
                  filled
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="4" class="mb-n5">
                <v-textarea
                  v-model="formulario.recursos"
                  filled
                  label="Recursos"
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="4" class="mb-n5">
                <v-textarea
                  v-model="formulario.criticidade"
                  label="Criticidade"
                  filled
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>

              <v-col cols="4">
                <v-select
                  v-model="formulario.tipologia"
                  :items="['PROGRESSIVA', 'CUMULATIVA']"
                  label="Tipologia"
                  :rules="[(v) => !!v || 'Tipologia é obrigatória.']"
                  filled
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-textarea
                  v-model="formulario.valorDeBase"
                  label="Valor de Base"
                  rows="1"
                  filled
                  auto-grow
                  :rules="[(v) => !!v || 'Valor de Base é obrigatório.']"
                ></v-textarea>
              </v-col>
              <v-col cols="4">
                <v-textarea
                  v-model="formulario.totalEsperado"
                  label="Total Esperado"
                  rows="1"
                  :rules="[(v) => !!v || 'Total Esperado é obrigatório.']"
                  auto-grow
                  filled
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-btn color="secondary" @click.prevent="fecharELimpar"
              >Cancelar</v-btn
            >
            <v-btn :loading="isFetching" color="primary" type="submit"> Salvar </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </template>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    titulo: {
      require: true,
    },
    logicaIntervencao: {
      require: true,
    },
  },
  computed: {
    ...mapState('indicador', {
      isFetching: state => state.isFetching,
    }),    

    impacto() {
      return this.logicaIntervencaoByNivel("OBJETIVO_GERAL");
    },
    realizacao() {
      return this.logicaIntervencaoByNivel("OBJETIVO_ESPECIFICO");
    },
    produto() {
      return this.logicaIntervencaoByNivel("RESULTADO_ESPERADO");
    },
    atividade() {
      return this.logicaIntervencaoByNivel("ATIVIDADE");
    },
    transition() {
      return 'dialog-bottom-transition'
    },
    responsaveis() {
      var payload = {
        'papel': 'AGENTE_LANCAMENTO_FONTES',
        'projetoId': parseInt(this.$route.params.projetoId),
      }
      return this.$store.getters["projeto/getParticipantesByPapel"](payload);
    }
  },
  data() {
    return {
      valid: true,
      dialog: false,
      formulario: {
        responsavel: { id: null },
        logicaIntervencao: null,
        listaPresenca: false,
        relatoriaReuniaoEncontro: false,
        planoOficinaIntercambioCaravana: false,
        relatoriaOficinaIntercambioCaravana: false,
        registroFotograficoModelado: false,
      },
      formulariosSelecionados: [],
      items: [
        {
          nome: "Relatoria de Reunião",
          ativo: false,
          tipo: "RELATORIA_REUNIAO_ENCONTRO",
        },
        {
          nome: "Plano de Oficina Intercâmbio Caravana e Encontro",
          ativo: false,
          tipo: "PLANO_OFICINA_INTERCAMBIO_CARAVANA",
        },
        {
          nome: "Relatoria de Oficina Intercâmbio Caravana e Encontro",
          ativo: false,
          tipo: "RELATORIA_OFICINA_INTERCAMBIO_CARAVANA",
        },
        {
          nome: "Informe de Reunião",
          ativo: false,
          tipo: "INFORME_REUNIAO",
        },        
      ],
    };
  },
  watch: {
    'formulario.valorDeBase'() {
      this.formulario.valorDeBase = this.formulario.valorDeBase.replace(',', '.')
    },
    'formulario.totalEsperado'() {
      this.formulario.totalEsperado = this.formulario.totalEsperado.replace(',', '.')
    }
  },
  methods: {
    ...mapActions("indicador", ["criarIndicador"]),

    save() {
      if (this.$refs.form.validate()) {
        this.create()
          .then((indicador) => {
            this.$emit("save", { indicador });
            this.fecharELimpar();
          })
          .catch((error) => {
            if (error.response) {
              this.errorMessage = error.response.data;
            }
          }).catch(error => {
           console.log(error) 
          });
      }
    },
    
    create() {
      const array = Object.values(this.formulariosSelecionados);

      if(array.length) {
        this.formulario.listaPresenca = array.some(item => item.tipo === "LISTA_PRESENCA"),
        this.formulario.relatoriaReuniaoEncontro = array.some(item => item.tipo === "RELATORIA_REUNIAO_ENCONTRO"),
        this.formulario.planoOficinaIntercambioCaravana = array.some(item => item.tipo === "PLANO_OFICINA_INTERCAMBIO_CARAVANA"),
        this.formulario.relatoriaOficinaIntercambioCaravana = array.some(item => item.tipo === "RELATORIA_OFICINA_INTERCAMBIO_CARAVANA"),
        this.formulario.registroFotograficoModelado = array.some(item => item.tipo === "REGISTRO_FOTOGRAFICO_MODELADO")
        this.formulario.informeReuniao = array.some(item => item.tipo === "INFORME_REUNIAO")
      }

      const payload = {
        id: this.logicaIntervencao.id,
        indicador: { ...this.formulario },
      };
      payload;

      return this.criarIndicador(payload);
    },

    fecharELimpar() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.formulario = {
        responsavel: { id: null },
        logicaIntervencao: null,
        listaPresenca: false,
        relatoriaReuniaoEncontro: false,
        planoOficinaIntercambioCaravana: false,
        relatoriaOficinaIntercambioCaravana: false,
        registroFotograficoModelado: false,
      },
      this.dialog = false;
    },

    logicaIntervencaoByNivel(nivel) {
      switch (nivel) {
        case "OBJETIVO_GERAL":
          if (this.logicaIntervencao.nivel === "OBJETIVO_GERAL") {
            return this.logicaIntervencao;
          }
          break;
        case "OBJETIVO_ESPECIFICO":
          if (this.logicaIntervencao.nivel === "ATIVIDADE") {
            return this.logicaIntervencao.logicaIntervencao.logicaIntervencao;
          } else if (this.logicaIntervencao.nivel === "RESULTADO_ESPERADO") {
            return this.logicaIntervencao.logicaIntervencao;
          } else if (this.logicaIntervencao.nivel === "OBJETIVO_ESPECIFICO") {
            return this.logicaIntervencao;
          }
          break;
        case "RESULTADO_ESPERADO":
          if (this.logicaIntervencao.nivel === "ATIVIDADE") {
            return this.logicaIntervencao.logicaIntervencao;
          } else if (this.logicaIntervencao.nivel === "RESULTADO_ESPERADO") {
            return this.logicaIntervencao.logicaIntervencao;
          }
          break;
        case "ATIVIDADE":
          if (this.logicaIntervencao.nivel === "ATIVIDADE") {
            return this.logicaIntervencao;
          }
          break;
      }
    },
  },
};
</script>
